/** Noise Table — channel registry (SPA). */
export const SITE_NAME = 'Noise Table';
export const HOME_CHANNEL_ID = 'bounce';

export const PROJECTS = [
  { ch: 1, id: 'bounce', name: 'bounce', vcrLabel: 'BOUNCE', vcrBg: '#b977ad', desc: 'physics + music', native: true },
  { ch: 2, id: 'winter', name: 'winter', vcrLabel: 'WINTER', vcrBg: '#2c6b74', desc: 'generative snowfall sequencer', native: true },
  { ch: 3, id: 'scan', name: 'scan', vcrLabel: 'SCAN', vcrBg: '#32742c', desc: 'radio looper · granular sampler', native: true },
  { ch: 4, id: 'drippy', name: 'drippy', vcrLabel: 'DRIPPY', vcrBg: '#847a35', desc: 'ambient drone with weather', native: true },
  { ch: 5, id: 'circles', name: 'circles', vcrLabel: 'CIRCLES', vcrBg: '#5a6d94', desc: 'harmonic ambient visualizer', native: true },
  { ch: 6, id: 'grid', name: 'grid', vcrLabel: 'GRID', vcrBg: '#742c63', desc: 'nine wireframe glyphs · rotating mysteries', native: true },
  { ch: 7, id: 'agnes', name: 'agnes', vcrLabel: 'AGNES', vcrBg: '#77b7b9', desc: 'color field generator', native: true },
  { ch: 8, id: 'tomboy', name: 'tomboy', vcrLabel: 'TOMBOY', vcrBg: '#c5712c', desc: 'op-1 tombola · physics sequencer', native: true },
  { ch: 9, id: 'gogia', name: 'gogia', vcrLabel: 'GOGIA', vcrBg: '#2a3d4f', desc: 'awake · dual loop transpose', native: true },
  { ch: 10, id: 'cruise', name: 'cruise', vcrLabel: 'CRUISE', vcrBg: '#141820', desc: 'infinite mode-7 racer · visual sequencer', native: true },
  { ch: 11, id: 'luna', name: 'luna', vcrLabel: 'LUNA', vcrBg: '#080102', desc: 'moon phase ambient · night sky', native: true },
  { ch: 12, id: 'murmur', name: 'murmur', vcrLabel: 'MURMUR', vcrBg: '#0a0e14', desc: 'boids flocking · ambient resonance', native: true },
  { ch: 13, id: 'train', name: 'train', vcrLabel: 'TRAIN', vcrBg: '#040410', desc: '4-voice drone · pixel city · ambient dark', native: true },
  { ch: 14, id: 'stoch', name: 'stoch', vcrLabel: 'STOCH', vcrBg: '#07070f', desc: 'stochastic clouds · after Xenakis', native: true },
  { ch: 15, id: 'about', name: 'about', vcrLabel: 'ABOUT', vcrBg: '#060408', desc: 'credits · provenance', native: true },
];

export function indexOfId(id) {
  return PROJECTS.findIndex((p) => p.id === id);
}

export function projectAt(idx) {
  if (idx < 0 || idx >= PROJECTS.length) return null;
  return PROJECTS[idx];
}

export function parseChannelFromPath(pathname) {
  const parts = pathname.split('/').filter(Boolean).map((p) => decodeURIComponent(p).toLowerCase());
  if (parts.length === 0) return null;
  const id = parts[0];
  const idx = indexOfId(id);
  return idx >= 0 ? { idx, project: PROJECTS[idx] } : null;
}

/** Dynamic import map — all channels are native modules. */
export async function loadNativeChannel(id) {
  switch (id) {
    case 'bounce':
      return import('./bounce/index.js');
    case 'winter':
      return import('./winter/index.js');
    case 'scan':
      return import('./scan/index.js');
    case 'drippy':
      return import('./drippy/index.js');
    case 'circles':
      return import('./circles/index.js');
    case 'grid':
      return import('./grid/index.js');
    case 'agnes':
      return import('./agnes/index.js');
    case 'tomboy':
      return import('./tomboy/index.js');
    case 'gogia':
      return import('./gogia/index.js');
    case 'cruise':
      return import('./cruise/index.js');
    case 'luna':
      return import('./luna/index.js');
    case 'murmur':
      return import('./murmur/index.js');
    case 'train':
      return import('./train/index.js');
    case 'stoch':
      return import('./stoch/index.js');
    case 'about':
      return import('./about/index.js');
    default:
      return null;
  }
}
